import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import qs from 'qs';
import { ToastProgrammatic as Toast } from 'buefy';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    status: '',
    token: sessionStorage.getItem('token') || '',
    userName: sessionStorage.getItem('userName') || '',
    selectedClient: sessionStorage.getItem('selectedClient') || ''
  },
  mutations: {
    AUTH_REQUEST(state) {
      state.status = 'loading';
    },
    AUTH_SUCCESS(state, { token, userName, selectedClient }) {
      state.status = 'success';
      state.token = token;
      state.userName = userName;
      state.selectedClient = selectedClient;
    },
    AUTH_ERROR(state) {
      state.status = 'error';
      state.token = '';
    },
    LOGOUT(state) {
      state.status = '';
      state.token = '';
      state.userName = '';
      state.selectedClient = '';
    }
  },
  actions: {
    // eslint-disable-next-line
    async login({ commit }, login) {
      try {
        // Destructure the Payload, grab our values
        const { username, password, selectedClient } = login;

        // Build our Authentication Payload for IMIS
        const payload = {
          username: username,
          password: password,
          selectedClient: selectedClient
        };

        // Mutate State - Update Status
        commit('AUTH_REQUEST');

        // Send our Data to IMIS and attempt our Auth
        const response = await axios.post(
          'https://utilities-server.ksam.co.uk/authenticate',
          qs.stringify(payload)
        );

        // Grab the values needed from the API Response
        const data = response.data;
        const token = data.access_token;
        const userName = data.userName;

        // Store our Values in Local Storage
        sessionStorage.setItem('token', token);
        sessionStorage.setItem('userName', userName);
        sessionStorage.setItem('selectedClient', selectedClient);

        // Set our default Axios Header (allowing us to call subsequent requests with our Authenticated user)
        axios.defaults.headers.common['Authorization'] = token;

        // Mutate State - Authentication Successful, store the values
        commit('AUTH_SUCCESS', { token, userName, selectedClient });

        // Notify the user of the Login Success
        Toast.open({
          message: `You were logged in successfully as ${userName} for: ${selectedClient}`,
          type: 'is-success'
        });
      } catch (error) {
        // Set the Error State
        commit('AUTH_ERROR');
        // Remove our Token
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('userName');
        sessionStorage.removeItem('selectedClient');

        if (error.response.status === 400) {
          // Notify user of error
          Toast.open({
            message: `The username and password provided is incorrect`,
            type: 'is-danger'
          });
        } else {
          // Notify user of error
          Toast.open({
            message: `An error occured, please try again - ${error.message}`,
            type: 'is-danger'
          });
        }
      }
    },
    async logout({ commit }) {
      // Mutate State - Reset all State values
      commit('LOGOUT');

      // Remove our values from sessionStorage
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('userName');
      sessionStorage.removeItem('selectedClient');

      // Remove our Axios default header so unauthorised requests cannot take place.
      delete axios.defaults.headers.common['Authorization'];

      // Notify the user they've been logged out.
      Toast.open({
        message: 'You were logged out successfully!',
        type: 'is-success'
      });
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    currentClient: state => state.selectedClient
  }
});
